import { Mail, RectangleEllipsis, Send, User } from "lucide-react";

export const onboardingSteps: {
  slug: string;
  title: string;
  description: string;
  icon: React.ElementType;
}[] = [
  {
    slug: "sign-up/welcome",
    title: "Welcome",
    description: "Join your organisation",
    icon: Send,
  },
  {
    slug: "sign-up/your-details",
    title: "Your Details",
    description: "Confirm details and define a password",
    icon: User,
  },
  {
    slug: "sign-up/confirm-email",
    title: "Confirm Email",
    description: "Confirm email address",
    icon: Mail,
  },
  {
    slug: "auth/setup-2fa",
    title: "Setup 2FA",
    description: "Configure 2-factor authentication",
    icon: RectangleEllipsis,
  },
];
